import { integrationApi, type Integration } from "@repo/api";
import { useQuery } from "@tanstack/react-query";

/**
 * React Query hook to fetch a single integration by ID
 */
export function useIntegrationById(integrationId: number | null | undefined) {
  return useQuery({
    queryKey: ["integration", integrationId],
    queryFn: async (): Promise<Integration> => {
      if (!integrationId) {
        throw new Error("Integration ID is required");
      }
      return await integrationApi.getIntegrationById(integrationId);
    },
    enabled: !!integrationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
}
